<div>
  <div class="mt-4">
    <div class="mb-3 flex flex-col w-full items-center gap-4">
      <div class="w-full ga-4 flex justify-center align-start">
        <form [formGroup]="form" class="flex justify-center ga-4 align-start">
          @if (showMunicipSelect) {
          <mat-form-field class="input-tg px-2" appearance="outline">
            <mat-label>Município</mat-label>
            <mat-select formControlName="municipio"  (selectionChange)="onMunicipioChange()">
              @for (municipio of municipiosList; track municipio.id) {
                <mat-option [value]="municipio.id">{{ municipio.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
          @if (showUnidadeSelect) {
          <mat-form-field class="input-tg px-2" appearance="outline">
            <mat-label>Unidade de Saúde</mat-label>
            <mat-select
              formControlName="unidadeSaude"
              [disabled]="!isSelectHealthUnitActive"
              (selectionChange)="onUnidadeSaudeChange()"
            >
              @for (unidadeS of unidadeSaudeList; track unidadeS.id) {
                <mat-option [value]="unidadeS.id">{{ unidadeS.nome }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </form>

      </div>
    </div>
    @if (checkPermission('visualizar')) {
      <form-patient-search
        [search]="inputSearch"
        [listSearch]="listSearch"
        (responseSearch)="search($event)"
      />
    }
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
